import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { Homepage, HomepageProps } from './Homepage';

export const LoggedInHomepage = (props: Omit<HomepageProps, 'isLoggedIn'>) => {
    const router = useRouter();

    useEffect(() => {
        if (typeof window === undefined) {
            return;
        }

        let isDismounting = false;

        if (
            !isDismounting &&
            window.location.pathname.includes('index-logged-in')
        ) {
            router.replace('/');
        }

        return () => {
            isDismounting = true;
        };
    }, [router]);

    return <Homepage isLoggedIn {...props} />;
};
